// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coffretsCard {
  background: var(--clr-secondary);
  border-radius: 1em;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  /* padding: 1.5em; */
  /* max-width: 40rem; */
  width: 85%;
  /* max-width: 35rem; */
  flex-shrink: 0;
  box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.04);
}

.coffretsCard__content {
  display: flex;
  flex-direction: column;
}

.coffretsCard__imgContainer {
  width: 16rem;
}
.coffretsCard__imgContainer .swiper-container {
  height: 100%;
}

.coffretsCard .swiper-container {
  margin: 0 !important;
}
.coffretsCard .swiper-wrapper {
  padding: 0 !important;
}
.coffretsCard .swiper-slide {
  width: 100% !important;
}

.coffretsCard__imgContainer img {
  width: 100%;
  /* aspect-ratio: 3 / 2; */
  object-fit: cover;
  height: 15rem;
  border-radius: 1em;
  margin-bottom: 1rem;
  position: relative;
  z-index: 10;
}

.coffretsCard__imgContainer {
  background-color: #f8e9d7;
  width: 100%;
  /* aspect-ratio: 3 / 2; */
  object-fit: cover;
  height: 15rem;
  border-radius: 1em;
  margin-bottom: 1rem;
  overflow: hidden;
  -webkit-mask-image: -webkit-radial-gradient(white, black);
  position: relative;
}

.coffretsCard__imgContainer::after {
  display: block;
  content: "";
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  transform: translateX(-100%);

  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.74),
    transparent
  );

  animation: loadingSkeleton 0.8s infinite;
}

.coffretsCard__title {
  color: var(--clr-primary);
  font-size: 1.15rem;
  font-weight: bold;
}

.coffretsCard__description {
  width: 100%;
  margin: 1rem 0 1.5rem 0;
  line-height: 1.6;
}

.coffretsCard__more {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 1.5em;
  gap: 1rem;
  justify-content: space-between;
}

.coffretsCard__textBody {
  padding: 1.5em;
}

/* .coffretsCard__more > div {
  flex: 1 1 50%;
} */

.coffretsCard__more span {
  display: block;
}

.coffretsCard__optionsContainer span {
  font-size: 0.8rem;
  font-weight: bold;
  display: flex;
}

.coffretsCard__options {
  display: flex;
  /* flex-wrap: wrap; */

  gap: 0.5em;
}

.coffretsCard__option {
  /* padding: 1em 1.5em;
  border: 0.15rem solid var(--clr-primary);
  color: var(--clr-primary);
  font-size: 0.8rem;
  font-weight: bold;
  white-space: nowrap;
  cursor: pointer;
  border-radius: 3em; */
  margin-top: 0.5rem;
  margin-bottom: -0.8rem;
}

.coffretsCard__optionAnchor {
  padding: 1em 1.5em;
  display: block;
  border: 0.15rem solid var(--clr-primary);
  color: var(--clr-primary);
  font-size: 0.8rem;
  font-weight: bold;
  white-space: nowrap;
  cursor: pointer;
  border-radius: 3em;
  /* margin-top: 0.5rem;
  margin-bottom: -0.8rem; */
}

.coffretsCard__optionSelected {
  font-size: 0.8rem;
  font-weight: bold;
  color: var(--clr-gray500);
}

.coffretsCard__more {
  margin-bottom: 0.8rem;
}

.coffretsCard__textBody > span {
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 1em;
  background: var(--clr-primary);
  color: #fff;
  padding: 1em 1.25em;
  font-size: 0.8rem;
  cursor: pointer;
}

.coffrets__counterContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 20%;
  width: 100%;
  max-width: 8rem;
  margin-top: 0.5rem;
}

/* .coffrets__counterContainer .btn-add,
.coffrets__counterContainer .btn-minus {
  background: var(--clr-light);
} */

.coffrets__counterContainer .btn-add::after,
.coffrets__counterContainer .btn-add::before,
.coffrets__counterContainer .btn-minus::after {
  background: var(--clr-light);
}

.coffrets__counterContainer .btn-add,
.coffrets__counterContainer .btn-minus {
  background: var(--clr-primary);
}

.coffrets__counterContainer > span {
  margin-bottom: 0.5rem;
  font-size: 0.8rem;
  font-weight: bold;
  color: var(--clr-gray500);
}

.coffrets__counter {
  display: flex;
  width: 100%;
  max-width: 7rem;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
}

.coffrets__counter span {
  font-weight: bolder;
  margin-bottom: -0.1rem;
  color: var(--clr-primary);
}

.coffretsCard__textPrice span {
  font-size: 1.25rem;
  color: var(--clr-primary);
  font-weight: bold;
  line-height: 1;
  margin-bottom: -0.25rem;
  margin-top: 0.75rem;
}

.coffretsCard__textPrice {
  line-height: 1.5;
  margin-bottom: 0.5rem;
  font-size: 0.8rem;
  font-weight: bold;
  color: var(--clr-gray500);
}

@media (min-width: 375px) {
  .coffretsCard__options {
    flex-wrap: nowrap;
  }
}

@media (min-width: 420px) {
  .coffrets__counterContainer {
    margin-top: 0;
  }
}

@media (min-width: 425px) {
  .coffretsCard__more {
    flex-wrap: nowrap;
  }
}

@media (min-width: 768px) {
  /* .coffretsCard__imgContainer img {
    aspect-ratio: 5 / 2;
  } */

  .coffretsCard {
    width: 100%;
    max-width: 35rem;
  }

  .coffretsCard__content {
    flex-direction: row;
  }

  .coffretsCard__textBody {
    width: 100%;
    max-width: 18rem;
  }

  .coffretsCard__imgContainer img {
    height: 24rem;
  }

  .coffretsCard__imgContainer {
    height: 24rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CoffretComponents/CoffretsCard/CoffretsCard.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yDAAyD;EACzD,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,4BAA4B;;EAU5B;;;;;GAKC;;EAED,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;;EAErB,UAAU;AACZ;;AAEA;EACE;;;;;;;uBAOqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,wCAAwC;EACxC,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB;2BACyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;GAGG;;AAEH;;;EAGE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;KAEG;;EAEH;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".coffretsCard {\n  background: var(--clr-secondary);\n  border-radius: 1em;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  /* padding: 1.5em; */\n  /* max-width: 40rem; */\n  width: 85%;\n  /* max-width: 35rem; */\n  flex-shrink: 0;\n  box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.04);\n}\n\n.coffretsCard__content {\n  display: flex;\n  flex-direction: column;\n}\n\n.coffretsCard__imgContainer {\n  width: 16rem;\n}\n.coffretsCard__imgContainer .swiper-container {\n  height: 100%;\n}\n\n.coffretsCard .swiper-container {\n  margin: 0 !important;\n}\n.coffretsCard .swiper-wrapper {\n  padding: 0 !important;\n}\n.coffretsCard .swiper-slide {\n  width: 100% !important;\n}\n\n.coffretsCard__imgContainer img {\n  width: 100%;\n  /* aspect-ratio: 3 / 2; */\n  object-fit: cover;\n  height: 15rem;\n  border-radius: 1em;\n  margin-bottom: 1rem;\n  position: relative;\n  z-index: 10;\n}\n\n.coffretsCard__imgContainer {\n  background-color: #f8e9d7;\n  width: 100%;\n  /* aspect-ratio: 3 / 2; */\n  object-fit: cover;\n  height: 15rem;\n  border-radius: 1em;\n  margin-bottom: 1rem;\n  overflow: hidden;\n  -webkit-mask-image: -webkit-radial-gradient(white, black);\n  position: relative;\n}\n\n.coffretsCard__imgContainer::after {\n  display: block;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transform: translateX(-100%);\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(transparent),\n    color-stop(rgba(255, 255, 255, 0.74)),\n    to(transparent)\n  );\n\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.74),\n    transparent\n  );\n\n  animation: loadingSkeleton 0.8s infinite;\n}\n\n.coffretsCard__title {\n  color: var(--clr-primary);\n  font-size: 1.15rem;\n  font-weight: bold;\n}\n\n.coffretsCard__description {\n  width: 100%;\n  margin: 1rem 0 1.5rem 0;\n  line-height: 1.6;\n}\n\n.coffretsCard__more {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 1.5em;\n  gap: 1rem;\n  justify-content: space-between;\n}\n\n.coffretsCard__textBody {\n  padding: 1.5em;\n}\n\n/* .coffretsCard__more > div {\n  flex: 1 1 50%;\n} */\n\n.coffretsCard__more span {\n  display: block;\n}\n\n.coffretsCard__optionsContainer span {\n  font-size: 0.8rem;\n  font-weight: bold;\n  display: flex;\n}\n\n.coffretsCard__options {\n  display: flex;\n  /* flex-wrap: wrap; */\n\n  gap: 0.5em;\n}\n\n.coffretsCard__option {\n  /* padding: 1em 1.5em;\n  border: 0.15rem solid var(--clr-primary);\n  color: var(--clr-primary);\n  font-size: 0.8rem;\n  font-weight: bold;\n  white-space: nowrap;\n  cursor: pointer;\n  border-radius: 3em; */\n  margin-top: 0.5rem;\n  margin-bottom: -0.8rem;\n}\n\n.coffretsCard__optionAnchor {\n  padding: 1em 1.5em;\n  display: block;\n  border: 0.15rem solid var(--clr-primary);\n  color: var(--clr-primary);\n  font-size: 0.8rem;\n  font-weight: bold;\n  white-space: nowrap;\n  cursor: pointer;\n  border-radius: 3em;\n  /* margin-top: 0.5rem;\n  margin-bottom: -0.8rem; */\n}\n\n.coffretsCard__optionSelected {\n  font-size: 0.8rem;\n  font-weight: bold;\n  color: var(--clr-gray500);\n}\n\n.coffretsCard__more {\n  margin-bottom: 0.8rem;\n}\n\n.coffretsCard__textBody > span {\n  width: fit-content;\n  border-radius: 1em;\n  background: var(--clr-primary);\n  color: #fff;\n  padding: 1em 1.25em;\n  font-size: 0.8rem;\n  cursor: pointer;\n}\n\n.coffrets__counterContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1 1 20%;\n  width: 100%;\n  max-width: 8rem;\n  margin-top: 0.5rem;\n}\n\n/* .coffrets__counterContainer .btn-add,\n.coffrets__counterContainer .btn-minus {\n  background: var(--clr-light);\n} */\n\n.coffrets__counterContainer .btn-add::after,\n.coffrets__counterContainer .btn-add::before,\n.coffrets__counterContainer .btn-minus::after {\n  background: var(--clr-light);\n}\n\n.coffrets__counterContainer .btn-add,\n.coffrets__counterContainer .btn-minus {\n  background: var(--clr-primary);\n}\n\n.coffrets__counterContainer > span {\n  margin-bottom: 0.5rem;\n  font-size: 0.8rem;\n  font-weight: bold;\n  color: var(--clr-gray500);\n}\n\n.coffrets__counter {\n  display: flex;\n  width: 100%;\n  max-width: 7rem;\n  gap: 0.5rem;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.coffrets__counter span {\n  font-weight: bolder;\n  margin-bottom: -0.1rem;\n  color: var(--clr-primary);\n}\n\n.coffretsCard__textPrice span {\n  font-size: 1.25rem;\n  color: var(--clr-primary);\n  font-weight: bold;\n  line-height: 1;\n  margin-bottom: -0.25rem;\n  margin-top: 0.75rem;\n}\n\n.coffretsCard__textPrice {\n  line-height: 1.5;\n  margin-bottom: 0.5rem;\n  font-size: 0.8rem;\n  font-weight: bold;\n  color: var(--clr-gray500);\n}\n\n@media (min-width: 375px) {\n  .coffretsCard__options {\n    flex-wrap: nowrap;\n  }\n}\n\n@media (min-width: 420px) {\n  .coffrets__counterContainer {\n    margin-top: 0;\n  }\n}\n\n@media (min-width: 425px) {\n  .coffretsCard__more {\n    flex-wrap: nowrap;\n  }\n}\n\n@media (min-width: 768px) {\n  /* .coffretsCard__imgContainer img {\n    aspect-ratio: 5 / 2;\n  } */\n\n  .coffretsCard {\n    width: 100%;\n    max-width: 35rem;\n  }\n\n  .coffretsCard__content {\n    flex-direction: row;\n  }\n\n  .coffretsCard__textBody {\n    width: 100%;\n    max-width: 18rem;\n  }\n\n  .coffretsCard__imgContainer img {\n    height: 24rem;\n  }\n\n  .coffretsCard__imgContainer {\n    height: 24rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
